import { render } from "./CargoCard.vue?vue&type=template&id=7af64f25&scoped=true&ts=true"
import script from "./CargoCard.vue?vue&type=script&lang=ts"
export * from "./CargoCard.vue?vue&type=script&lang=ts"

import "./CargoCard.vue?vue&type=style&index=0&id=7af64f25&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af64f25"]])

export default __exports__